<div class="sidebar" [class.collapsed]="isCollapsed">
    <div class="sidebar-header">
        <button
            mat-icon-button
            type="button"
            class="sidebar-toggle"
            (click)="toggleNav()"
            [attr.aria-label]="'admin.nav.toggle' | transloco"
        >
            <mat-icon>menu</mat-icon>
        </button>
    </div>

    <nav class="sidebar-nav" [class.nav--collapsed]="isCollapsed" [attr.aria-label]="'admin.nav.label' | transloco">
        <div class="nav-section">
            @for (item of navItems; track item.link) {
                <a
                    class="nav-item"
                    [routerLink]="item.link"
                    routerLinkActive="active"
                    [matTooltip]="item.labelKey | transloco"
                    matTooltipPosition="right"
                    [matTooltipDisabled]="!isCollapsed"
                >
                    <mat-icon class="nav-icon">{{ item.icon }}</mat-icon>
                    <span class="nav-label">{{ item.labelKey | transloco }}</span>
                </a>
            }
        </div>
    </nav>
</div>
